import {ApiClient} from '@hconnect/apiclient'
import {useMutation, useQueryClient, type UseMutationOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'

import {
  CommentKpiValue,
  ExpertSystemEquipmentType,
  YearMonth,
  MtmKpiValueQueryKey,
  CommentsQueryKey,
  DailyKpiValuesQueryKey
} from '../types'

const mutationKey = 'comment-kpi-delete-mtm-value'

export const useCommentKpiDelete = (
  kpiTargetEquipmentType: ExpertSystemEquipmentType,
  hierarchyId: string,
  yearMonth: YearMonth,
  options?: UseMutationOptions<CommentKpiValue[], AxiosError<{message?: string}>, {id: string}>
) => {
  const queryClient = useQueryClient()

  return useMutation<CommentKpiValue[], AxiosError<{message?: string}>, {id: string}>({
    mutationKey: [mutationKey, kpiTargetEquipmentType, hierarchyId, yearMonth],
    mutationFn: async ({id}) => {
      const response = await ApiClient.axiosInstance.delete<CommentKpiValue[]>(
        `/expert-system/kpis/${kpiTargetEquipmentType}/mtm/${yearMonth}/${hierarchyId}/comments/${id}`
      )
      return response.data
    },
    ...options,
    onSuccess: async (...args) => {
      await queryClient.invalidateQueries({
        queryKey: [CommentsQueryKey]
      })
      await queryClient.invalidateQueries({queryKey: [MtmKpiValueQueryKey]})
      await queryClient.invalidateQueries({queryKey: [DailyKpiValuesQueryKey]})
      await options?.onSuccess?.(...args)
    },
    ...options
  })
}
